import React, { Component } from 'react';
import Utility from '../../../Utility';
import './ScrollWrapper.css';

import ReactResizeDetector from 'react-resize-detector';

const SCROLLBAR_HEIGHT = 12;
const MINMAP_MAX_HEIGHT = 40;

/*
	I've made a conscious decision not to break the minimap and scrollbar into individual React componenets.
	Since I'm animating these properties, I don't think setState will be performant enough to smoothly move things
*/
class ScrollWrapper extends Component {
	constructor(props) {
		super(props);

		this.sliderRef = React.createRef();
		this.scrollerRef = React.createRef();

		this.scrollerTID = null;

		if (this.props.minimap === true) {
			// Minimap
			this.minihandleRef = React.createRef();
		}

		if (this.props.scrollbar === true) {
			// Scrollbar
			this.scrollbarHandleRef = React.createRef();
			this.scrollbarRef = React.createRef();
		}

		// Last mouse position in the X direction
		this.lastMousePosition = 0;

		// Essentially the last delta X
		this.velocity = 0;

		// Target left position of scrolling element
		this.scrollLeft = 0;

		// Whether the mouse button is down or not
		this.mouseDownForScroller = false;
		this.mouseDownForHandle = false;

		// current requestAnimationFrame ID
		this.timer = 0;

		// How much we are allowed to scroll the pane
		this.maxScroll = 0;

		// Width of the scrollable area
		this.scrollableWidth = 0;

		this.state = {
			// Related to overall scrollable dimensions
			paneWidth: 0,
			paneHeight: 0,
			scrollableWidth: 0,

			// Controls how wide the mini map and mini map handle are
			minimapWidth: 0,
			minimapHandleWidth: 0,

			// Controls how wide the scroll handle is
			scrollHandleWidth: 0
		}
	}

	componentDidMount() {
		window.addEventListener('mousemove', this.mousemoveHandlerForScroller);
		window.addEventListener('mouseup', this.mouseupHandlerForScroller);

		if (this.props.scrollbar === true) {
			window.addEventListener('mousemove', this.mousemoveHandlerForHandle);
		}

		if (this.props.scrollbar || this.props.minimap) {
			window.addEventListener('mouseup', this.mouseupHandlerForHandle);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('mousemove', this.mousemoveHandlerForScroller);
		window.removeEventListener('mouseup', this.mouseupHandlerForScroller);

		if (this.props.scrollbar === true) {
			window.removeEventListener('mousemove', this.mousemoveHandlerForHandle);
		}

		if (this.props.scrollbar || this.props.minimap) {
			window.removeEventListener('mouseup', this.mouseupHandlerForHandle);
		}
	}

	// stopPropagation = (ev) => {
	// 	ev.stopPropagation();
	// }

	makeEaseInOut = (timing) => {
		return (timeFraction) => {
			if (timeFraction < .5) {
				return timing(2 * timeFraction) / 2;
			} else {
				return (2 - timing(2 * (1 - timeFraction))) / 2;
			}
		}
	}

	circ = (timeFraction) => {
		return 1 - Math.sin(Math.acos(timeFraction));
	}

	animate = ({timing, draw, duration}) => {
		let start = performance.now();

		requestAnimationFrame(function animate(time) {
			// timeFraction goes from 0 to 1
			let timeFraction = (time - start) / duration;
			if (timeFraction > 1) timeFraction = 1;

			// calculate the current animation state
			let progress = timing(timeFraction)

			draw(progress); // draw it

			if (timeFraction < 1) {
				requestAnimationFrame(animate);
			}
		});
	}

	shift = (direction) => {
		// get width of whiteboard
		var shift = (1/3) * this.state.paneWidth;

		var easeInOut = this.makeEaseInOut(this.circ);

		switch (direction) {
			case 'left':
				direction = -1;
				break;
			case 'right':
				direction = 1;
				break;
			default:
		}

		var _this = this,
			currentScrollLeft = _this.sliderRef.current.scrollLeft;

		this.animate({
			duration: 250,
			timing: easeInOut,
			draw: (progress) => {
				_this.sliderRef.current.scrollLeft = currentScrollLeft + (progress * direction * shift);
			}
		});
	}

	mousemoveHandlerForScroller = (ev) => {
		if (this.mouseDownForScroller === true) {
			var delta = this.lastMousePosition - ev.pageX;
			this.velocity = delta;
			this.direction = delta;
			this.lastMousePosition = ev.pageX;
			this.scrollLeft += delta;

			if (this.scrollLeft < 0) {
				this.scrollLeft = 0;
			}

			if (this.scrollLeft > this.maxScroll) {
				this.scrollLeft = this.maxScroll;
			}
		}
	}

	scroll = () => {
		// TODO: cap FPS
		if (this.mouseDownForScroller === false && this.mouseDownForHandle === false) {
			if (this.velocity !== 0) {

				var _this = this,
					currentStep = 0,
					velocity = Math.abs(this.velocity),
					direction = Math.sign(this.velocity);

				requestAnimationFrame(function animate(time) {
					if (_this.mouseDownForScroller === false) {
						// timeFraction goes from 0 to 1
						var stepProgress = currentStep / 50,
							progress = 1 - (_this.slowEaseOut(stepProgress));

						_this.sliderRef.current.scrollLeft += direction * velocity; // draw it

						// Decrease velocity
						velocity *= (.85*progress);
						currentStep++;

						// if (stepProgress < 1) {
						if (velocity > 0.05) {
							requestAnimationFrame(animate);
						}
					}
				});
			}
		} else {
			// While the mouse is down, always call this
			this.sliderRef.current.scrollLeft = this.scrollLeft;
			requestAnimationFrame(this.scroll);
		}
	}

	slowEaseOut = (stepPercent) => {
		return Math.pow(stepPercent, 3);
	}

	onMousedownHandlerForScroller = (ev) => {
		if (ev.button === 0) {
			// If an animation is in progress, cancel it
			cancelAnimationFrame(this.timer);

			document.documentElement.classList.add("draggable-cursor");

			this.maxScroll = this.scrollableWidth - this.sliderRef.current.offsetWidth;

			// Mouse button was pressed
			this.mouseDownForScroller = true;

			// Capture current scroll position
			this.scrollLeft = this.sliderRef.current.scrollLeft;

			// Reset velocity
			this.velocity = 0;

			// Capture current mouse position
			this.lastMousePosition = ev.pageX;

			// Start animating
			this.timer = requestAnimationFrame(this.scroll);
		}
	}

	mouseupHandlerForScroller = (ev) => {
		if (this.mouseDownForScroller === true && ev.button === 0) {
			this.mouseDownForScroller = false;
			document.documentElement.classList.remove("draggable-cursor");
		}
	}

	onScrollHandlerForScroller = () => {
		clearTimeout(this.scrollerTID);
		this.scrollerRef.current.classList.add('scrolling');
		this.scrollerTID = Utility.delay(250, () => { this.scrollerRef.current.classList.remove('scrolling'); }, this);

		if (this.mouseDownForHandle === false) {
			if (this.props.scrollbar === true) {
				var handlePosition = (this.state.paneWidth - this.state.scrollHandleWidth) * (this.sliderRef.current.scrollLeft / this.maxScroll);
				this.scrollbarHandleRef.current.style.transform = 'translate3D(' + handlePosition + 'px, 0, 0)';
			}

			if (this.props.minimap === true && this.state.minimapWidth > 0) {
				var minimapHandlePosition = (this.state.minimapWidth - this.state.minimapHandleWidth) * (this.sliderRef.current.scrollLeft / this.maxScroll);
				this.minihandleRef.current.style.transform = 'translate3D(' + minimapHandlePosition + 'px, 0, 0)';
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.paneWidth > 0 && this.state.paneHeight > 0) {
			// When either the image dimension changes, or the scroll window size changes, we need to recalc our layout
			var prevKey = prevProps.originalImageDimensions.w + ':' + prevProps.originalImageDimensions.h + ':' + prevState.paneWidth + ':' + prevState.paneHeight;
			var currentKey = this.props.originalImageDimensions.w + ':' + this.props.originalImageDimensions.h + ':' + this.state.paneWidth + ':' + this.state.paneHeight;

			if (prevKey !== currentKey) {
				if (this.props.width) {
					this.scrollableWidth = this.props.width;
				} else {
					this.scrollableWidth = (this.props.originalImageDimensions.w / this.props.originalImageDimensions.h) * this.state.paneHeight;
				}

				this.maxScroll = this.scrollableWidth - this.sliderRef.current.offsetWidth;

				if (this.scrollableWidth > 0 && (this.props.scrollbar === true || this.props.minimap === true)) {
					var minimapWidth = 200;

					if (this.state.paneWidth - 40 < 200) {
						minimapWidth = this.state.paneWidth - 40;
						if (minimapWidth < 20) {
							minimapWidth = 0;
						}
					}

					if (minimapWidth * (this.state.paneHeight / this.scrollableWidth) > MINMAP_MAX_HEIGHT) {
						minimapWidth = MINMAP_MAX_HEIGHT * (this.scrollableWidth / this.state.paneHeight);
					}

					this.setState({
						scrollHandleWidth: this.state.paneWidth * (this.state.paneWidth / this.scrollableWidth),
						minimapWidth: minimapWidth,
						minimapHandleWidth: minimapWidth * (this.state.paneWidth / this.scrollableWidth)
					}, this.onScrollHandlerForScroller);
				}
			}
		}

		if (prevProps.position !== this.props.position) {
			this.jumpToScrollPosition(this.props.position);
		}
	}

	// Handlers for scrollbar
	clickHandlerForScrollbar = (ev) => {
		if (this.mouseDownForHandle === false) {
			// If an animation is in progress, cancel it
			cancelAnimationFrame(this.timer);

			// Are we to the LEFT or RIGHT of the handle?
			var mousePosition = Utility.getOffsetX(ev, this.scrollbarRef.current),
				handlePosition = Utility.getElementRelativeOffsetX(this.scrollbarHandleRef.current, this.scrollbarRef.current);

			var direction = Math.sign(mousePosition - handlePosition);

			var newScrollPosition = this.sliderRef.current.scrollLeft + (direction * (this.state.paneWidth - 120));

			this.velocity = 0;

			if (newScrollPosition < 0) {
				newScrollPosition = 0;
			}

			if (newScrollPosition > this.maxScroll) {
				newScrollPosition = this.maxScroll;
			}

			this.scrollLeft = newScrollPosition;

			this.sliderRef.current.scrollLeft = this.scrollLeft;
		}
	}

	// Handlers for scrollbar handle
	clickHandlerForHandle = (ev) => {
		// Don't bubble events to scrollbar
		ev.stopPropagation();
	}

	onMousedownHandlerForHandle = (ev) => {
		if (ev.button === 0) {
			// If an animation is in progress, cancel it
			cancelAnimationFrame(this.timer);

			document.documentElement.classList.add("draggable-cursor");
			this.scrollbarRef.current.classList.add('scrolling');

			this.maxScroll = this.scrollableWidth - this.sliderRef.current.offsetWidth;

			// Mouse button was pressed
			this.mouseDownForHandle = true;

			// Capture current scroll position
			this.scrollLeft = this.sliderRef.current.scrollLeft;

			// Reset velocity
			this.velocity = 0;

			// Capture current mouse position relative to scrollbar
			// this.lastMousePosition = Utility.getOffsetX(ev, this.scrollbarRef.current);

			// Capture current mouse position
			this.lastMousePosition = ev.pageX;

			// Start animating
			this.timer = requestAnimationFrame(this.scroll);
		}
	}

	mousemoveHandlerForHandle = (ev) => {
		if (this.mouseDownForHandle === true) {
			var delta = -1 * (this.lastMousePosition - ev.pageX);
			this.lastMousePosition = ev.pageX;

			var currentHandlePosition = Utility.getElementRelativeOffsetX(this.scrollbarHandleRef.current, this.scrollbarRef.current);

			var newHandlePosition = currentHandlePosition + delta;

			if (newHandlePosition < 0) {
				newHandlePosition = 0;
			}

			if (newHandlePosition > (this.state.paneWidth - this.state.scrollHandleWidth)) {
				newHandlePosition = this.state.paneWidth - this.state.scrollHandleWidth;
			}

			// calculate scroll postiton based on handle position
			this.scrollLeft = (newHandlePosition * this.maxScroll) / (this.state.paneWidth - this.state.scrollHandleWidth);

			if (this.scrollLeft < 0) {
				this.scrollLeft = 0;
			}

			if (this.scrollLeft > this.maxScroll) {
				this.scrollLeft = this.maxScroll;
			}

			this.scrollbarHandleRef.current.style.transform = 'translate3D(' + newHandlePosition + 'px, 0, 0)';
		}
	}

	mouseupHandlerForHandle = (ev) => {
		if (this.mouseDownForHandle === true && ev.button === 0) {
			this.mouseDownForHandle = false;
			document.documentElement.classList.remove("draggable-cursor");
			this.scrollbarRef.current.classList.remove('scrolling');
			ev.stopPropagation();
		}
	}

	onResizeHandler = (width, height) => {
		if (this.props.height) {
			height = this.props.height;
		}

		this.setState({
			paneWidth: width,
			paneHeight: height
		});
	}

	jumpToScrollPosition = (newScrollPosition) => {
		if (newScrollPosition < 0) {
			newScrollPosition = 0;
		}

		if (newScrollPosition > this.maxScroll) {
			newScrollPosition = this.maxScroll;
		}

		this.scrollLeft = newScrollPosition;

		if (newScrollPosition !== this.sliderRef.current.scrollLeft) {
			var _this = this,
				currentStep = 0,
				distance = newScrollPosition - this.sliderRef.current.scrollLeft,
				start = this.sliderRef.current.scrollLeft;

			requestAnimationFrame(function animate(time) {
				// timeFraction goes from 0 to 1
				var stepProgress = currentStep / 20,
					progress = _this.slowEaseOut(stepProgress);

				_this.sliderRef.current.scrollLeft = start + (distance * progress);

				currentStep++;

				if (progress < 1) {
					requestAnimationFrame(animate);
				}
			});
		}
	}

	render() {
		var minimapClass = 'minimap',
			scrollbarClass = 'scrollbar';

		if ((this.props.minimap || this.props.scrollbar) && this.sliderRef && this.sliderRef.current) {
			if (this.sliderRef.current.scrollWidth <= this.sliderRef.current.clientWidth) {
				minimapClass += ' hidden';
				scrollbarClass += ' hidden';
			}
		}

		return (
			<div className="scrollwrapper" id={this.props.id} style={{ height: this.props.height + 'px' }}>
				<div className="scroller" ref={this.scrollerRef} style={{ height: (this.state.paneHeight - (SCROLLBAR_HEIGHT*this.props.scrollbar)) + 'px' }} onMouseDown={this.onMousedownHandlerForScroller}>

					{this.props.minimap ? <div className={minimapClass} style={{ width: this.state.minimapWidth + 'px', height: this.state.minimapWidth * (this.state.paneHeight / this.scrollableWidth) + 'px' }}>
						<div ref={this.minihandleRef} className="minihandle" style={{ width: this.state.minimapHandleWidth + 'px' }}></div>
					</div> : null}

					<div style={{ height: '100%', position: 'relative' }}>
						<div ref={this.sliderRef} className="slider" onScroll={this.onScrollHandlerForScroller}>
							{this.props.children}
						</div>
					</div>
				</div>

				{this.props.scrollbar ? <div ref={this.scrollbarRef} className={scrollbarClass} style={{ height: (SCROLLBAR_HEIGHT-2) + 'px' }} onClick={this.clickHandlerForScrollbar}>
					<div ref={this.scrollbarHandleRef} className="scrollbarhandle" style={{ width: this.state.scrollHandleWidth + 'px', height: (SCROLLBAR_HEIGHT-2) + 'px' }} onClick={this.clickHandlerForHandle} onMouseDown={this.onMousedownHandlerForHandle}></div>
				</div> : null}

				<ReactResizeDetector handleWidth handleHeight onResize={this.onResizeHandler} refreshMode="debounce" refreshOptions={{ leading: false, trailing: true }} refreshRate={250} />
			</div>
		);
	}
};

export default ScrollWrapper;